<template>
  <div id="user_import">
    <div class="container">
      <!--UPLOAD-->
      <form @submit.prevent="post" method="post" enctype="multipart/form-data" novalidate
            v-if="isInitial || isFilled || isSaving">
        <h1>Upload images</h1>
        <div class="dropbox">
          <input type="file" :name="uploadFieldName" :disabled="isSaving"
                 @change="handleUploadedFile($event.target.files);"
                 accept="image/*" class="input-file">
          <p v-if="isInitial">
            Drag your file(s) here to begin<br> or click to browse
          </p>
          <p v-if="isFilled">
            Chosen file : {{ uploadedFile.name }}
          </p>
          <p v-if="isSaving">
            Uploading file ...
          </p>
        </div>
        <input type="submit">
      </form>

      <p v-if="isSuccess">
        Number created : {{ nb_created }}
      </p>
    </div>
  </div>
</template>

<script>
  const STATUS_INITIAL = 0, STATUS_FILLED = 1, STATUS_SAVING = 2, STATUS_SUCCESS = 3, STATUS_FAILED = 4;

  export default {
    name: 'UserImport',
    data() {
      return {
        uploadError: null,
        currentStatus: null,
        uploadedFile: null,
        uploadFieldName: 'file',
        nb_created: 0
      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isFilled() {
        return this.currentStatus === STATUS_FILLED;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL;
        this.uploadError   = null;
      },
      post(){
        this.currentStatus = STATUS_SAVING;

        var formData = new FormData();
        formData.append("file", this.uploadedFile);

        this.$http.post(`user/import`, formData, {
            errorHandle: false,
            successHandle: false
          }
        ).then(response => {
          this.currentStatus = STATUS_SUCCESS;
          this.nb_created    = response.data.nb_created
        }).catch(error => {
          this.currentStatus = STATUS_FAILED;
        })
      },
      handleUploadedFile(files){
        this.uploadedFile  = files[0];
        this.currentStatus = STATUS_FILLED;
      }
    },
    mounted() {
      this.reset();
    },
  }
</script>

<style>
  .dropbox {
    outline:        2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background:     #bfbfbf;
    color:          black;
    padding:        10px 10px;
    min-height:     200px; /* minimum height */
    position:       relative;
    cursor:         pointer;
  }

  .input-file {
    opacity:  0; /* invisible but it's there! */
    width:    100%;
    height:   200px;
    position: absolute;
    cursor:   pointer;
  }

  .dropbox:hover {
    background: #a5a5a5; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size:  1.2em;
    text-align: center;
    padding:    50px 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/User/import.vue